import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-scene',
  templateUrl: './no-scene.component.html',
  styleUrls: ['./no-scene.component.scss'],
})
export class NoSceneComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
